/**
 * RGBW Light Template
 * For devices with RGB + White color control
 */

import {
	createTurnAction,
	createStateCondition,
	createStateChangedTrigger,
} from '../../common/stateManagement.js';
import {
	createSetBrightnessAction,
	createBrightnessLevelCondition,
	createBrightnessChangedTrigger,
} from '../../common/brightnessManagement.js';
import {
	createSetColorAction,
	createSetColorHexAction,
	createSetEffectAction,
	createColorMatchesCondition,
	createEffectActiveCondition,
	createColorChangedTrigger,
	createEffectChangedTrigger,
} from '../../common/colorManagement.js';

/**
 * Create RGBW light template with color and brightness control
 * @returns {Object} Scene capabilities for RGBW light
 */
export function createRgbwTemplate() {
	return {
		deviceType: 'rgbw',
		channels: ['light:0'],

		actions: {
			turn: createTurnAction('Light.Set', 'output'),
			setBrightness: createSetBrightnessAction(),
			setColor: createSetColorAction(),
			setColorHex: createSetColorHexAction(),
			setEffect: createSetEffectAction(),
		},

		conditions: {
			isOn: createStateCondition('output'),
			brightnessLevel: createBrightnessLevelCondition(),
			colorMatches: createColorMatchesCondition(),
			effectActive: createEffectActiveCondition(),
		},

		triggers: {
			stateChanged: createStateChangedTrigger('output'),
			brightnessChanged: createBrightnessChangedTrigger(),
			colorChanged: createColorChangedTrigger(),
			effectChanged: createEffectChangedTrigger(),
		},
	};
}
